// extracted by mini-css-extract-plugin
export default {"ProTableWrapper":"ProTable_ProTableWrapper__jtTji","row":"ProTable_row__7kASj","cell":"ProTable_cell__m3+UA","noBorder":"ProTable_noBorder__HhNo3","dotted":"ProTable_dotted__FsO4h"};